<template lang="pug">
  .modal-card
    header.modal-card-head
      p.modal-card-title Add new reseller
      button.delete(@click="$emit('close')")
    section.modal-card-body
      .modal-guide
        p Please enter the following information to create a new reseller. All fields are required.
      BField(label="Reseller name")
        BInput(
          v-model="form.name"
          placeholder="Reseller name"
          :disabled="submitting"
        )
      .columns
        .column
          BField.pr-3(label="Admin first name")
            BInput(
              v-model="form.firstName"
              placeholder="First name"
              :disabled="submitting"
            )
        .column
          BField(label="Admin last name")
            BInput(
              v-model="form.lastName"
              placeholder="Last name"
              :disabled="submitting"
            )
      BField(label="Admin's phone number")
        BInput(
          v-model="form.phone"
          placeholder="0-000-000-0000"
          :disabled="submitting"
        )
      BField(label="Admin's email address")
        BInput(
          v-model="form.email"
          placeholder="Email address"
          type="email"
          :disabled="submitting"
        )
    footer.modal-card-foot
      WtButton.cancel-btn(
        @click.native="$emit('close')"
        :disabled="submitting"
      )
        | Cancel
      WtButton.submit-btn(
        @click.native="submit"
        :loading="submitting"
      )
        | Add reseller
</template>

<script>
import { mapActions } from "vuex";
import WtButton from "@@/WtButton/WtButton.vue";

export default {
  name: "AddResellerModal",

  components: { WtButton },

  data() {
    return {
      form: {
        name: "",
        firstName: "",
        lastName: "",
        phone: "",
        email: ""
      },
      submitting: false
    };
  },

  computed: {
    isValid() {
      return (
        this.form.name &&
        this.form.firstName &&
        this.form.lastName &&
        this.form.phone &&
        this.form.email
      );
    }
  },

  methods: {
    ...mapActions(["snackBar"]),

    async submit() {
      if (!this.isValid) {
        this.snackBar({
          message: "Please fill in all fields.",
          type: "is-warning"
        });
        return;
      }

      this.submitting = true;
      try {
        const { data } = await this.axios.post("super/reseller", this.form);
        this.$emit("added", data.data);
      } catch (error) {
        console.error("Error creating reseller:", error);
        const message =
          error.response?.data?.message || "Failed to create reseller.";
        this.snackBar({
          message,
          type: "is-danger"
        });
      } finally {
        this.submitting = false;
      }
    }
  }
};
</script>

<style lang="sass" scoped>
.modal-card-head
  padding: 20px 16px 20px 16px

.modal-card-title
  font-family: Manrope
  font-weight: 600
  font-size: 18px
  line-height: 28px

.modal-card-body
  padding: 16px
  display: flex
  flex-direction: column
  gap: 10px

  .modal-guide
    opacity: 1;
    gap: 10px;
    padding-bottom: 10px;

    p
      font-weight: 400;
      font-size: 15px;
      line-height: 23px;
      letter-spacing: 0px;
      color: #1B1D20;
      margin: 0px;

  p
    font-family: Manrope
    font-weight: 400
    font-size: 15px
    line-height: 23px
    margin-bottom: 24px

  ::v-deep .field
    angle: 0 deg;
    opacity: 1;
    border-radius: 8px;
    gap: 6px;
    padding: Spacing/None;
    display: flex;
    flex-direction: column;
    margin: 0px

    label
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: 0px;
      color: #1B1D20;
      margin: 0px


  .columns
    margin: 0px;

    .column
      padding: 0px;

.modal-card-foot
  padding: 12px 16px
  gap: 10px
  display: flex
  justify-content: flex-end

  ::v-deep .wt-button
    font-weight: 600
    font-size: 16px
    line-height: 24px
    border-radius: 10px
    padding: 8px 16px !important
    height: 40px
    display: flex
    align-items: center
    justify-content: center
    transition: all 0.2s ease-in-out
    cursor: pointer

    &.cancel-btn
      background-color: #E8EBEF !important
      color: #2972F0 !important
      border: 1px solid #2972F0 !important

      &:hover:not(:disabled)
        opacity: 0.95

      &:active:not(:disabled)
        opacity: 0.9

    &.submit-btn
      background-color: #2972F0 !important
      color: #FFFFFF !important

      &:hover:not(:disabled)
        opacity: 0.95

      &:active:not(:disabled)
        opacity: 0.9

    &:disabled
      opacity: 0.6
      cursor: not-allowed
</style>
